import { useState } from 'react'
import { ReservationSearchDocument, ReservationSearchQuery, ReservationSearchQueryVariables, reservationSearchFragment } from 'src/api/api.generated'
import QueryLookup from '../query-lookup/query-lookup'
import { useHotelDate, useTenant } from 'src/app/hooks/context/context.hook'
import { Stack, Avatar, Typography } from '@vapor/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBed } from '@fortawesome/pro-regular-svg-icons'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'

type ReservationLookupProps = {
  propertyId: string
  value: reservationSearchFragment | { id: string }
  onChange: (value: reservationSearchFragment | null) => void
}
export const ReservationLookup = (props: ReservationLookupProps) => {
  const { propertyId, value, onChange } = props
  const { id: tenantId } = useTenant()
  const formatDate = useFormatDate()
  const hotelDate = useHotelDate()

  return (
    <>
      <QueryLookup<reservationSearchFragment, ReservationSearchQuery, ReservationSearchQueryVariables> //
        value={value ? value : null}
        onChange={onChange}
        queryDocument={ReservationSearchDocument}
        fetchQueryVariables={(id) => ({
          filter: {
            id: id,
            tenantId: tenantId,
            propertyId: propertyId,
          },
          limit: 1,
        })}
        getFetchRecord={(data: ReservationSearchQuery) => data.reservationSearch?.[0] || null}
        searchQueryVariables={(text) => ({
          filter: {
            tenantId: tenantId,
            propertyId: propertyId,
            search: text,
            filterType: 'DEPARTURE',
            filterFrom: hotelDate,
          },
        })}
        getSearchRecords={(data: ReservationSearchQuery) => data.reservationSearch || []}
        getOptionLabel={(option) => `${option.reservationCode} - ${option.mainGuest}`}
        renderOption={(value) => {
          return (
            <Stack direction="row" alignItems="center" spacing={1} width="100%" minWidth={{ xs: '100%', sm: '350px', md: '450px' }}>
              <Avatar>
                <FontAwesomeIcon icon={faBed} style={{ width: '18px', height: '18px', color: 'var(--Cadet)' }} />
              </Avatar>
              <Stack key={value.id} direction="column" spacing={0.5}>
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={0.5}>
                  <Typography variant="caption" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <b>{`${value.reservationCode} - ${value.company ? `${value.company} (${value.mainGuest})` : value.mainGuest}`}</b>
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                  <Typography variant="caption">{`${formatDate(value.start)} > ${formatDate(value.end)}`}</Typography>
                </Stack>
              </Stack>
            </Stack>
          )
        }}
      />
    </>
  )
}
